__turbopack_context__.v({
  "banner": "DebugBanner-module-scss-module__aWEX2q__banner",
});
